import JobTitleSuggestion from 'app/employer/pages/job/components/JobTitleSuggestion';
import withAutoSuggestFormik from './withAutoSuggestFormik';
import withInputErrorMessage from '../withInputErrorMessage';

export default withAutoSuggestFormik(withInputErrorMessage(JobTitleSuggestion));
